var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#CEDCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9504 64.2688L60.0064 70.4608L68.736 64.4384L88.304 83.744C87.7888 83.9104 87.2384 84 86.6656 84H33.3344C32.6304 84 31.9584 83.8624 31.3408 83.616L50.9504 64.2688ZM92 48.4032V78.6656C92 79.456 91.8272 80.2048 91.52 80.88L72.3392 61.9552L92 48.4032ZM28 48.5728L47.3344 61.7952L28.3392 80.5408C28.1142 79.9412 27.9993 79.306 28 78.6656V48.5728ZM86.6656 36C89.6096 36 92 38.3872 92 41.3344V43.2096L59.9936 65.2736L28 43.392V41.3344C28 38.3904 30.3872 36 33.3344 36H86.6656Z",
    fill: "#4974D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconEmail);
export default __webpack_public_path__ + "static/media/img-icon-email.9dd13ad08665e1bd9bd107b67699016e.svg";
export { ForwardRef as ReactComponent };